import { render, staticRenderFns } from "./AtualizarUpfPr.vue?vue&type=template&id=09402d32&scoped=true&"
import script from "./AtualizarUpfPr.vue?vue&type=script&lang=js&"
export * from "./AtualizarUpfPr.vue?vue&type=script&lang=js&"
import style0 from "./AtualizarUpfPr.vue?vue&type=style&index=0&id=09402d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09402d32",
  null
  
)

export default component.exports